import classNames from "classnames";
import { Icon } from "PFComponents/icon";
import { LoadingDots } from "PFComponents/loading_dots";
import { useEffect, useState } from "react";

import { ChatAttachmentItem } from "./chat_attachment_input";
import css from "./chat_attachments.module.scss";

type ChatAttachmentProps = {
  attachment: ChatAttachmentItem;
  removeAttachment: (attachment: ChatAttachmentItem) => void;
};

const ChatAttachment = ({ attachment, removeAttachment }: ChatAttachmentProps) => {
  const [showName, setShowName] = useState(false);
  const { fake, fileObjectUrl } = attachment;

  useEffect(() => {
    const image = new Image();
    image.onerror = () => setShowName(true);
    image.src = attachment.fileObjectUrl as string;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames(css.item, { [css.fake]: fake })}>
      <div className={css.wrap}>
        {showName ? (
          <div className={css.name}>{attachment.fileName}</div>
        ) : (
          <div className={css.img} style={{ backgroundImage: `url(${fileObjectUrl})` }} />
        )}
      </div>
      {fake && (
        <div className={css.loading}>
          <LoadingDots />
        </div>
      )}
      {!fake && (
        // eslint-disable-next-line max-len
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className={css.remove} onClick={() => removeAttachment(attachment)}>
          <Icon name="remove" size="sm" color="paletteWhite0" />
        </div>
      )}
    </div>
  );
};

type ChatAttachmentsProps = {
  attachments: ChatAttachmentItem[];
  removeAttachment: (attachment: ChatAttachmentItem) => void;
};

export const ChatAttachments = ({ attachments, removeAttachment }: ChatAttachmentsProps) => (
  <div className={css.root}>
    {attachments.map((attachment) => (
      <ChatAttachment key={attachment.id} attachment={attachment} removeAttachment={removeAttachment} />
    ))}
  </div>
);
